import {
  Box,
  IconButton,
  Popover,
  Tooltip,
  Typography,
  List
} from "@mui/material";
import Stack from '@mui/material/Stack';
import { InsertDriveFile} from "@mui/icons-material";
import SettingsIcon from '@mui/icons-material/Settings';
import { useState, useRef, useEffect } from "react";
import { getAllTemplates } from "../api/admin/Template";
import TemplateEntry from "./TemplateEntry";

/**
 * A TemplatePopover is a react component used to display all available templates to choose from.
 * @returns 
 */
const TemplatePopover = () => {
  const anchorRef = useRef(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  /*
  const [dialogOpen, setDialogOpen] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const [isFullscreen, setIsFullscreen] = useState(false);
    */

  const [foundTemplates, setTemplates] = useState([]);

  const handlePopoverOpen = () => setPopoverOpen(true);
  const handlePopoverClose = () => setPopoverOpen(false);

  function handleManageTemplates(){
      window.location.href = '/dashboard/admin-setting/manage-excel-template';
  }

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    const res = await getAllTemplates();
    if (res?.data) {
      setTemplates(res.data);
    }
  };

  return (
    <>
      <Tooltip title="Templates">
        <IconButton
          size="small"
          color="inherit"
          ref={anchorRef}
          onClick={handlePopoverOpen}
        >
          <InsertDriveFile fontSize="medium" />
        </IconButton>
      </Tooltip>

      <Popover
        anchorEl={anchorRef.current}
        open={popoverOpen}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        PaperProps={{
          sx: { width: 250 },
        }}
      >
        <Box sx={{margin: 2}}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography color="textPrimary" variant="h6">
            Excel Templates
          </Typography>

          {/* Display icon to upload a template. */}
          <Tooltip title = "Manage Templates">
            <IconButton
              onClick={handleManageTemplates}
            >
              <SettingsIcon/>
            </IconButton>
          </Tooltip>
        </Stack>
        </Box>

        <List>
          {foundTemplates.map((currentTemplate) => (
            <TemplateEntry
              template = {currentTemplate}
            />
          ))}
        </List>
      </Popover>

      {/* Unsure of why this is here.
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        fullScreen={isFullscreen}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          {isFullscreen ? "Template (Fullscreen)" : "Template"}
        </DialogTitle>
        <DialogContent>
          <iframe
            title="Excel Templates"
            src={iframeUrl}
            width="100%"
            height="600px"
            style={{
              border: "none",
              height: isFullscreen ? "100vh" : "600px",
            }}
          />
        </DialogContent>
        
        <DialogActions>
          <Button
            onClick={toggleFullscreen}
            color="primary"
            startIcon={<Fullscreen />}
          >
            {isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
          </Button>
          <Button
            onClick={handleDialogClose}
            color="secondary"
            startIcon={<Close />}
          >
            Close
          </Button>
        </DialogActions>
        
      </Dialog>
      */}
    </>
  );
};

export default TemplatePopover;
